export default __webpack_public_path__ + "static/media/withdrawal.9e7ee807.svg";